import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { isHex } from '../../utils/ColorUtils';
import { background, bgWrapper } from './ComponentBg.module.scss';
gsap.registerPlugin(ScrollTrigger);

const Background = ({ id, widthTrigger, markers, color }) => {
  // In addition to the props, Trigger elements also need a data-color attribute that uses a color name, like "Midnight"

  const bgWrapperRef = useRef();
  const bgRef = useRef();
  // Resize the background
  useEffect(() => {
    let mm = gsap.matchMedia();
    let bgContext = gsap.context(() => {
      // Runs only on tablet-landscape and up
      mm.add('(min-width: 0px)', () => {
        // Get all the widthTriggers
        let widthTriggers = gsap.utils.toArray(widthTrigger);

        // Find the widthTrigger for this background component
        const thisTrigger = widthTriggers.find(
          (trigger) => trigger.getAttribute('data-id') === id
        );

        // Create a tween to animate the background
        const sizeTl = gsap.timeline({});
        sizeTl
          .to(
            bgWrapperRef.current,
            {
              padding: 0,
              duration: 0.5,
              ease: 'power2.inOut',
            },
            '0'
          )
          .to(
            bgRef.current,
            {
              borderRadius: 0,
              duration: 0.5,
              ease: 'power2.inOut',
            },
            '0'
          );

        // Use ScrollTrigger animation to run the tween
        ScrollTrigger.create({
          id: `width`,
          trigger: thisTrigger,
          start: 'top 85%',
          end: 'bottom 85%',
          // markers: true,
          animation: sizeTl,
          toggleActions: 'play none none reverse',
          refreshPriority: -20,
          // These don't seem to be needed any more. I think because, unlike PageBg, they use the animation property instead of callbacks
          // invalidateOnRefresh: true, // this updates the style values when the window resizes
          // onRefresh: (self) => {
          // Force the background to expand if the page is refreshed after scrolling
          // self.progress === 1 && self.animation.progress(1);
          // },
        });
      });
    });
    return () => {
      bgContext.revert();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className={`${bgWrapper}`} ref={bgWrapperRef}>
      <div
        className={`${background} texturedBgVarColor ${
          isHex(color) ? '' : 'varColor' + color
        } `}
        ref={bgRef}
        style={isHex(color) ? { '--var-color': color } : {}}
      ></div>
    </div>
  );
};

Background.propTypes = {
  bgSelector: PropTypes.string,
  triggerSelector: PropTypes.string,
  markers: PropTypes.bool,
};

export default Background;
